// 商品类型
export const PRODUCT_TYPE_ALL = 'typeall';
export const PRODUCT_TYPE_OTHER = 'typeother';

// 商品搜索类型
export const PRODUCT_SEARCH_BY_NAME = 'name';
export const PRODUCT_SEARCH_BY_PRICE = 'price';

// 商品排序类型
export const PRODUCT_ORDER_BY_NORMAL = 'normal';
export const PRODUCT_ORDER_BY_TYPE = 'type';
export const PRODUCT_ORDER_BY_PRICE_UP = 'priceUp';
export const PRODUCT_ORDER_BY_PRICE_DOWN = 'priceDown';
